var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3303_104053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.56812 15.75C5.85886 16.4185 6.33854 16.9876 6.94823 17.3873C7.55792 17.787 8.27108 18 9.00012 18C9.72915 18 10.4423 17.787 11.052 17.3873C11.6617 16.9876 12.1414 16.4185 12.4321 15.75H5.56812Z",
    fill: "#858D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7941 9.41176L15.4921 5.11951C15.0752 3.61827 14.1686 2.29934 12.9165 1.37213C11.6644 0.44493 10.1384 -0.0374034 8.58079 0.00171693C7.02321 0.0408372 5.52334 0.599169 4.31933 1.58806C3.11531 2.57696 2.27616 3.93973 1.9351 5.46001L0.9241 9.61276C0.789725 10.1646 0.782445 10.7397 0.902808 11.2947C1.02317 11.8498 1.26803 12.3702 1.61892 12.8168C1.9698 13.2634 2.41754 13.6245 2.92834 13.8727C3.43914 14.121 3.99966 14.25 4.5676 14.25H13.2053C13.7909 14.25 14.3683 14.1129 14.8914 13.8497C15.4144 13.5864 15.8685 13.2044 16.2174 12.7341C16.5662 12.2638 16.8001 11.7183 16.9002 11.1414C17.0004 10.5645 16.964 9.97211 16.7941 9.41176Z",
    fill: "#858D9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3303_104053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.535edfbc57af31623d173a1b356e1de6.svg";
export { ForwardRef as ReactComponent };